export const RESET_FORM = 'RESET_FORM';

export const resetForms = () => ({
  type: RESET_FORM,
});
